import { render, staticRenderFns } from "./manage-access.vue?vue&type=template&id=f362a5f0&scoped=true&"
import script from "./manage-access.vue?vue&type=script&lang=js&"
export * from "./manage-access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f362a5f0",
  null
  
)

export default component.exports